import { ref } from 'vue'

const scrollValue = ref(null)

export { scrollValue }
